var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58003 19.8237L9.49707 18.5559C9.60422 18.528 9.70256 18.4718 9.78072 18.3874L16.9538 10.6344C17.1939 10.375 17.1525 9.94631 16.8614 9.677L13.8784 6.91707C13.5873 6.64776 13.1567 6.63977 12.9167 6.89923L5.74359 14.6522C5.66664 14.7353 5.61861 14.8359 5.59845 14.943L4.63722 18.9514C4.57925 19.1932 4.66873 19.4626 4.86836 19.6473C5.06799 19.832 5.3435 19.9003 5.58003 19.8237Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3252 5.37678C14.0851 5.63624 14.1265 6.06488 14.4176 6.33419L17.4006 9.09412C17.6917 9.36343 18.1223 9.37142 18.3623 9.11196L20.2155 7.10901C20.4555 6.84956 20.4141 6.42092 20.1231 6.15161L17.14 3.39168C16.8489 3.12237 16.4184 3.11438 16.1783 3.37383L14.3252 5.37678Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidPen);
export default __webpack_public_path__ + "static/media/solid-pen.91357667e310519920c34f63d7bdadc1.svg";
export { ForwardRef as ReactComponent };